import Cauldron from "./Cauldron";
import TechOrbit from "./TechOrbit";
import { TECH_CHIPS } from "../../constants/techChips";

const HeroVisual = () => (
  <div className="hero__visual reveal" aria-hidden="true">
    <div className="hero__ring hero__ring--outer" />
    <div className="hero__ring hero__ring--mid" />
    <div className="hero__ring hero__ring--inner" />
    <Cauldron />
    <TechOrbit chips={TECH_CHIPS} />
  </div>
);

export default HeroVisual;
